import { extend } from '@thd-nucleus/data-sources';

import { MessagingContainerDataModel } from './MessagingContainerDataModel';

export const PodCallToActionDataModel = extend(MessagingContainerDataModel);
